import {RouterProvider} from "react-router-dom";

// project imports
import router from "routes";
import ThemeCustomization from "themes";

import ScrollTop from "components/ScrollTop";
import {Provider} from "react-redux";
import store from "./app/store";
import AlertProvider from "./provider/AlertProvider";

// ==============================|| APP - THEME, ROUTER, LOCAL ||============================== //

export default function App() {
    return (
        <Provider store={store}>
            <ThemeCustomization>
                <AlertProvider>
                    <ScrollTop>
                        <RouterProvider router={router}/>
                    </ScrollTop>
                </AlertProvider>
            </ThemeCustomization>
        </Provider>
    );
}
